<template>
    <div id="content">
        <link rel="stylesheet" href="/themes/ito/css/percentage-circle.css">
        <link rel="stylesheet" href="/themes/ito/css/leaderboard.css?v=18">

        <div class="container">

            <div id="leaderboard" class="card" style="height: calc(100vh - 190px);">
                <div class="card-body">
                    <h5 class="card-title">
                        <span class="title">{{ $t('leader_board') }}</span>

                        <button :class="'all_users' == filter_type ? 'btn btn-filter active' : 'btn btn-filter'" @click="filter('all_users')">
                            <img src="/themes/ito/images/earth.svg" alt="" />
                            {{ $t('all_user') }}
                        </button>
                        <button :class="'school' == filter_type ? 'btn btn-filter active' : 'btn btn-filter'" v-if="user_info.student_type == 1" @click="filter('school')">
                            <img src="/themes/ito/images/school.svg" alt="" />
                            {{ $t('school') }}
                        </button>
                        <div class="tools" style="width: 150px">
                            <div class="month-select">
                                <i class="ito-icon-next next" @click="prev"></i>
                                <span class="text">{{ month_txt }} {{ year }}</span>
                                <i :class="isNextDisable() ? 'ito-icon-prev prev prev-disable' : 'ito-icon-prev prev'" @click="next"></i>
                            </div>
                        </div>
                    </h5>

                    <div class="card-content">
                        <div class="leader-board">
                            <div class="leader-board-column gem">
                                <div class="leader-board-content">
                                    <div class="leader-board-header">
                                        <h3>{{ $t('top_gems_leaders') }}</h3>
                                        <img src="/themes/ito/images/icon-gem-3.svg" alt="" />
                                    </div>
                                    <div class="leader-board-body">
                                        <div class="nano" v-if="leaderboards.length > 0">
                                            <div class="nano-content d-flex flex-column gap-2">
                                                <div class="leader-board-item" v-for="(user, index) in leaderboards">
                                                    <div class="d-flex gap-3 overflow-hidden">
                                                        <div class="numb">
                                                            <img :src="getLevelUrl(index)" alt="" v-if="index <= 2" />
                                                            <span v-else>{{ index + 1 }}</span>
                                                        </div>
                                                        <div class="avatar">
                                                            <img class="img-fluid" :src="user.avatar_url" alt="" v-if="user.avatar_url" />
                                                            <img class="img-fluid" src="/themes/ito/images/avatar-default.svg" alt="" v-else />
                                                            <span class="emotion" v-if="user.emoji_url">
                                                                <img class="img-fluid" :src="user.emoji_url" alt="">
                                                            </span>
                                                        </div>
                                                        <div class="info">
                                                            <p> {{ user.fullname || user.username }}</p>
                                                            <small>{{ user.username }}</small>
                                                        </div>
                                                    </div>
                                                    <div class="d-flex gap-3">
                                                        <div class="value">
                                                            {{ user.gem || user.username }}
                                                            <i class="ito-icon-gem"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="leaderboard-empty-txt" v-else>
                                            {{ $t('no_leader_board') }}
                                        </div>
                                    </div>
                                </div>
                                <div class="leader-board-footer" v-if="leaderboards.length > 0">
                                    <div class="leader-board-item" v-if="my_rank && my_rank.rank != 0">
                                        <div class="d-flex gap-3 align-items-center">
                                            <div class="numb">
                                                {{ my_rank.rank }}
                                            </div>
                                            <div class="avatar">
                                                <img class="img-fluid" :src="my_rank.avatar_url" alt="" v-if="my_rank.avatar_url" />
                                                <img class="img-fluid" src="/themes/ito/images/avatar-default.svg" alt="" v-else />
                                                <span class="emotion" v-if="my_rank.emoji_url">
                                                    <img class="img-fluid" :src="my_rank.emoji_url" alt="">
                                                </span>
                                            </div>
                                            <div class="info">
                                                {{ my_rank.fullname || my_rank.username }}
                                            </div>
                                        </div>
                                        <div class="d-flex gap-3 align-items-center">
                                            <div class="value">
                                                {{ my_rank.gem | toCommas }}
                                                <i class="ito-icon-gem"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="leader-board-item no-rank" v-else>
                                        <p><b>{{ $t('you_not_rated') }}</b></p>
                                        {{ $t('leader_board_not_rated_gem_desc') }}
                                    </div>
                                </div>
                            </div>
                            <div class="leader-board-column crown">
                                <div class="leader-board-content">
                                    <div class="leader-board-header">
                                        <h3>{{ $t('top_crowns_leaders') }}</h3>
                                        <img src="/themes/ito/images/icon-crown-3.svg" alt="" />
                                    </div>
                                    <div class="leader-board-body">
                                        <div class="nano" v-if="crown_leaderboards.length > 0">
                                            <div class="nano-content d-flex flex-column gap-2">
                                                <div class="leader-board-item" v-for="(user, index) in crown_leaderboards">
                                                    <div class="d-flex gap-3 overflow-hidden">
                                                        <div class="numb">
                                                            <img :src="getLevelUrl(index)" alt="" v-if="index <= 2" />
                                                            <span v-else>{{ index + 1 }}</span>
                                                        </div>
                                                        <div class="avatar">
                                                            <img class="img-fluid" :src="user.avatar_url" alt="" v-if="user.avatar_url" />
                                                            <img class="img-fluid" src="/themes/ito/images/avatar-default.svg" alt="" v-else />
                                                            <span class="emotion" v-if="user.emoji_url">
                                                                <img class="img-fluid" :src="user.emoji_url" alt="">
                                                            </span>
                                                        </div>
                                                        <div class="info">
                                                            <p> {{ user.fullname || user.username }}</p>
                                                            <small>{{ user.username }}</small>
                                                        </div>
                                                    </div>
                                                    <div class="d-flex gap-3">
                                                        <div class="value">
                                                            {{ user.gem || user.username }}
                                                            <i class="ito-icon-crown"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="leaderboard-empty-txt" v-else>
                                            {{ $t('no_leader_board') }}
                                        </div>
                                    </div>
                                </div>
                                <div class="leader-board-footer" v-if="crown_leaderboards.length > 0">
                                    <div class="leader-board-item" v-if="crown_my_rank && crown_my_rank.rank != 0">
                                        <div class="d-flex gap-3 align-items-center">
                                            <div class="numb">
                                                {{ crown_my_rank.rank }}
                                            </div>
                                            <div class="avatar">
                                                <img class="img-fluid" :src="crown_my_rank.avatar_url" alt="" v-if="crown_my_rank.avatar_url" />
                                                <img class="img-fluid" src="/themes/ito/images/avatar-default.svg" alt="" v-else />
                                                <span class="emotion" v-if="crown_my_rank.emoji_url">
                                                    <img class="img-fluid" :src="crown_my_rank.emoji_url" alt="">
                                                </span>
                                            </div>
                                            <div class="info">
                                                {{ crown_my_rank.fullname || crown_my_rank.username }}
                                            </div>
                                        </div>
                                        <div class="d-flex gap-3 align-items-center">
                                            <div class="value">
                                                {{ crown_my_rank.gem | toCommas }}
                                                <i class="ito-icon-crown"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="leader-board-item no-rank" v-else>
                                        <p><b>{{ $t('you_not_rated') }}</b></p>
                                        {{ $t('leader_board_not_rated_crown_desc') }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from 'vuex'
import { getLeaderboard } from "../../models/leadboard";

export default {
    name: "LeaderBoardNormal",
    title: 'Leaderboard',

    data() {
        const d = new Date();
        const months = [
            this.$i18n.t('jan'),
            this.$i18n.t('feb'),
            this.$i18n.t('mar'),
            this.$i18n.t('apr'),
            this.$i18n.t('may'),
            this.$i18n.t('jun'),
            this.$i18n.t('jul'),
            this.$i18n.t('aug'),
            this.$i18n.t('sep'),
            this.$i18n.t('oct'),
            this.$i18n.t('nov'),
            this.$i18n.t('dec')
        ];
        const month = this.$route.query.month || d.getMonth() + 1;
        const year = this.$route.query.year || d.getFullYear();

        return {
            leaderboards: [],
            my_rank: null,
            crown_leaderboards: [],
            crown_my_rank: null,
            year: year,
            months: months,
            month: month,
            month_txt: months[month - 1],
            filter_type: 'all_users'
        };
    },

    computed: {
        ...mapGetters([
            'user_info'
        ], () => {
            if (this.user_info) {
                return this.user_info
            }

            return this.user
        })
    },

    watch: {
        $route() {
            this.fetch()
        }
    },

    created() {
        this.$store.commit("setMenuActive", "home");
        this.fetch();
    },

    methods: {
        fetch() {
            this.getData()
        },

        getLevelUrl(index) {
            const file_name_index = index + 1;
            return '/themes/ito/images/lb-level-' + file_name_index + '.svg'
        },

        isNextDisable() {
            const that = this;
            const date = new Date();
            const current_month = date.getMonth() + 1;
            const current_year = date.getFullYear();
            const year_next = that.month == 12 ? parseInt(that.year) + 1 : that.year;
            const month_next = that.month == 12 ? 1 : parseInt(that.month) + 1;

            if (current_year == year_next && current_month < month_next || current_year < year_next) {
                return true;
            }

            return false;
        },
        getData() {
            let that = this;
            that.$store.commit("setLoading", true);
            axios.all([
                getLeaderboard({
                    grade: that.user_info.grade,
                    school: that.filter_type == 'all_users' ? 0 : 1,
                    year: that.year,
                    month: that.month
                }),
            ]).then(axios.spread((response) => {
                that.$store.commit("setLoading", false);

                if (response.data.code != 0) {
                    return;
                }

                that.leaderboards = response.data.results.gem.leaderboard || [];
                that.my_rank = response.data.results.gem.my_rank || null;

                that.crown_leaderboards = response.data.results.crown.leaderboard || [];
                that.crown_my_rank = response.data.results.crown.my_rank || null;

                that.month_txt = that.months[that.month - 1];

                that.$nextTick(function () {
                    initNanoScroller();
                })
            }));
        },

        next() {
            const that = this;
            const date = new Date();
            const current_month = date.getMonth() + 1;
            const current_year = date.getFullYear();
            const year_next = that.month == 12 ? parseInt(that.year) + 1 : that.year;
            const month_next = that.month == 12 ? 1 : parseInt(that.month) + 1;

            if (current_year == year_next && current_month < month_next) {
                return;
            }
            that.year = year_next;
            that.month = month_next;
            this.getData();

        },

        prev() {
            const that = this;
            const year_prev = that.month == 1 ? parseInt(that.year) - 1 : that.year;
            const month_prev = that.month == 1 ? 12 : parseInt(that.month) - 1;

            that.year = year_prev;
            that.month = month_prev;
            this.getData();
        },

        filter(type) {
            this.filter_type = type;
            this.getData();
        }
    }
}
</script>

<style scoped>
.board-list-empty {
    margin: auto;
    text-align: center;
}

.level-items.top10::-webkit-scrollbar,
.level-items.top10::-webkit-scrollbar-thumb {
    width: 26px;
    border-radius: 13px;
    background-clip: padding-box;
    border: 10px solid transparent;
}

.level-items.top10::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 0 10px;
}

.level-items.top10:hover {
    color: rgba(0, 0, 0, 0.3);
}

#leaderboard .board>.board-left .row3 .board-right-message {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 19px;
    text-align: center;
    color: #000000;
    padding: 15px 5px;
}

#leaderboard .board>.board-left .row3 .board-right-message b {
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 22px;
    text-align: center;
    color: #000000;
}
</style>